import { render, staticRenderFns } from "./service-add-edit.vue?vue&type=template&id=c261b7ca&"
import script from "./service-add-edit.vue?vue&type=script&lang=js&"
export * from "./service-add-edit.vue?vue&type=script&lang=js&"
import style0 from "./service-add-edit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports